<template>
    <div :class="[appType]">
        <div class="summary-container">
            <a class="wplatomat-site-logo" :href="pageUrl" target="_blank">
                <img :src="require(`../../assets/images/${systemConst.SUMMARY_LOGO_NAME}`)" alt="logo" title="logo"/>
            </a>

          <div class="podziekowanie-block-error">
            <h2>Twoja płatność</h2>
            <h2>jest ciągle przetwarzana lub nie powiodła się</h2>
            <div class="error-notice">
              <div>Przetwarzanie niektórych transakcji zabiera więcej czasu niż standardowo.</div>
              <div><span class="exclamation">Sprawdź swój e-mail.</span> Jeśli płatność zakończy się powodzeniem -
                dostaniesz tam powiadomienie.
              </div>
            </div>
          </div>

            <div class="wplatomat-form longer-h2">
                <div class="payment-notice">Jeśli wpłata poprzez system Przelewy24 się nie powiedzie, możesz dokonać wpłaty w serwisie swojego banku, korzystając z danych poniżej.</div>
                <div class="wplatomat-block">
                    <h2>Dane do przelewu bankowego</h2>

                    <div class="wplatomat-info-block">
                        <label>Nr konta:</label>
                        <div class="block-info">21 1750 0012 0000 0000 2060 1264</div>
                    </div>

                    <div class="wplatomat-info-block">
                        <label>Odbiorca:</label>
                        <div class="block-info">Stowarzyszenie WIOSNA<br>ul. Wielicka 20<br> 30-552 Kraków</div>
                    </div>

                    <div class="wplatomat-info-block">
                        <label>Tytułem:</label>
                        <div class="block-info">{{ systemConst.PAYMENT_TITLE }}</div>
                    </div>
                </div>

                <div class="wplatomat-block">
                    <h2 class="to-bottom">Wpłaty z zagranicy</h2>

                    <div class="wplatomat-info-block">
                        <label>Kod SWIFT:</label>
                        <div class="block-info">PPABPLPKXXX</div>
                    </div>

                    <div class="wplatomat-info-block">
                        <label>Nasz bank to:</label>
                        <div class="block-info">BNP Paribas Bank Polska, ul. Kasprzaka 10/16, 01-211 Warszawa</div>
                    </div>

                    <div class="wplatomat-info-block margin-bottom">
                        <label>Nr konta w formacie IBAN:</label>
                        <div class="block-info">PL 21 1750 0012 0000 0000 2060 1264</div>
                    </div>
                </div>
            </div>

            <div class="podziekowanie-block-wsparcie">
                <h2>Dziękujemy za Twoje wsparcie!</h2>
            </div>
            <SummaryFooter />
        </div>
    </div>
</template>

<script>
import GtmTransaction from '../../mixins/GtmTransaction'
import systemConst from '@SYSTEM_CONSTANTS'
import SummaryFooter from '../organisms/SummaryFooter'

export default {
    name: 'ErrorPage',
    mixins: [GtmTransaction],
    data () {
        return {
            appType: process.env.VUE_APP_SYSTEM,
            pageUrl: process.env.VUE_APP_PAGE_URL,
            imagesPath: process.env.VUE_APP_DEFAULT_PAYMENT_IMAGES_PATH,
            systemConst
        }
    },
    components: {
        SummaryFooter
    }
}
</script>

<style scoped>
.summary-container {
    background-color: white;
}
</style>
